<script>
import { mapActions } from 'vuex';
import ManageStarsModal from '@/components/users/ManageStarsModal';
import TableView from '@/components/elements/views/TableView';

export default {
    components: {
        ManageStarsModal
    },

    extends: TableView,

    props: {
        userId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            includeHeader: false,
            includeDeleteAction: false
        };
    },

    computed: {
        additionalFetchData() {
            return {
                id: this.userId
            };
        },

        options() {
            return {
                clickableRows: false,
                addButtonText: 'Manage stars'
            };
        },

        labels() {
            return [
                { value: 'description', width: '200px' },
                {
                    value: 'stars',
                    width: '200px',
                    type: 'number',
                    sum: true
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        },

        additionalComponents() {
            return [
                {
                    name: 'manage-stars-modal',
                    props: {
                        userId: this.userId
                    },
                    events: {
                        changed: this.onChanged
                    }
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'users/getStarHistory'
        }),

        onAddButtonClick() {
            this.$bvModal.show('manage-stars-modal');
        },

        onChanged(item) {
            this.items = [item, ...this.items];

            this.$emit('change-stars', item.stars);
        }
    }
};
</script>
